<template>
	<div class="component-dropdown-menu-picker">
	<el-popover
		:popper-class="computedPopperClass"
		v-bind="$attrs"
		:disabled="disabled"
		:placement="$attrs.placement || 'bottom-start'"
		:visible-arrow="$attrs.visibleArrow || false"
		:trigger="$attrs.trigger || 'hover'"
		:transition="$attrs.transition || 'fade-to-bottom'"
		:close-delay="150"
		@show="actived = true"
		@hide="actived = false"
	>
		<template #reference>
			<div
				class="reference flex items-center cursor-pointer whitespace-nowrap hover:bm-text-effect"
				:class="[
					size,
					{
						actived: actived,
						'actived:bm-text-effect': actived,
					},
				]"
			>
				<template v-if="$slots.default">
					<slot />
				</template>
				<template v-else>
					<svg
						class="svgfont relative mr-1"
						version="1.1"
						xmlns="http://www.w3.org/2000/svg"
						width="512"
						height="512"
						viewBox="0 0 512 512"
						v-if="hot"
					>
						<path
							fill="#fa772d"
							d="M218.297 16c44.778 34.983 76.093 68.925 93.944 101.857 16.909 31.202 23.695 63.121 20.365 95.756l-0.647 5.44 3.318-2.712c11.904-10.229 21.079-23.254 26.704-37.906l1.462-4.034 4.174-12.536c44.654 30.331 66.986 81.701 66.986 154.099 0 108.589-95.152 177.909-173.351 177.909-78.218 0-167.256-46.452-181.662-143.671-14.393-97.204 45.299-142.588 85.96-205.905 27.126-42.207 44.695-84.977 52.749-128.293z"
						></path>
						<path
							fill="#faac2d"
							d="M215.646 128.016c34.599 26.939 58.793 53.077 72.583 78.435 13.063 24.028 18.31 48.606 15.734 73.739l-0.5 4.185 2.563-2.089c9.197-7.875 16.286-17.906 20.632-29.19l1.132-3.107 3.226-9.654c34.499 23.359 51.754 62.916 51.754 118.666 0 83.618-73.517 136.999-133.94 136.999-60.43 0-129.225-35.772-140.356-110.635-11.12-74.851 35-109.801 66.416-158.559 20.958-32.501 34.532-65.436 40.755-98.792z"
						></path>
					</svg>
					<span>{{ reference }}</span>
					<svg
						:class="[
							'svgfont svgfont-reference ml-1 bm-size-2 mt-[1px]',
							{
								actived: actived,
								'actived:bm-text-effect': actived,
							},
						]"
						version="1.1"
						xmlns="http://www.w3.org/2000/svg"
						width="512"
						height="512"
						viewBox="0 0 512 512"
					>
						<path fill="currentColor" d="M508 112l-252 288-252-288h504z"></path>
					</svg>
				</template>
			</div>
		</template>
		<div :style="{ width: width }">
			<!-- 支持自定义slot -->
			<div class="py-4" :class="[columns ? 'component-dropdown-menu-picker-columns-2' : '']" v-if="!$slots.content">
				<SensorTrack :datas="item.sensorData" v-for="item in list" :key="item.value">
					<nuxt-link-enhance
						:project="item.project"
						:to="item.to"
						:replace="item.replace"
						@click.native="onSelect(item)"
						v-if="item.show"
					>
						<span
							class="box-border flex items-center px-4 py-3 bm-size-3_5 leading-6 text-left cursor-pointer bm-bg-white hover:bm-bg-gray-100 group"
							:class="{ actived: item.selected }"
						>
							<svg
								class="svgfont relative ml-[4px] mr-[18px] bm-size-4_5"
								version="1.1"
								xmlns="http://www.w3.org/2000/svg"
								width="512"
								height="512"
								viewBox="0 0 512 512"
								v-if="item.hot"
							>
								<path
									fill="#fa772d"
									d="M218.297 16c44.778 34.983 76.093 68.925 93.944 101.857 16.909 31.202 23.695 63.121 20.365 95.756l-0.647 5.44 3.318-2.712c11.904-10.229 21.079-23.254 26.704-37.906l1.462-4.034 4.174-12.536c44.654 30.331 66.986 81.701 66.986 154.099 0 108.589-95.152 177.909-173.351 177.909-78.218 0-167.256-46.452-181.662-143.671-14.393-97.204 45.299-142.588 85.96-205.905 27.126-42.207 44.695-84.977 52.749-128.293z"
								></path>
								<path
									fill="#faac2d"
									d="M215.646 128.016c34.599 26.939 58.793 53.077 72.583 78.435 13.063 24.028 18.31 48.606 15.734 73.739l-0.5 4.185 2.563-2.089c9.197-7.875 16.286-17.906 20.632-29.19l1.132-3.107 3.226-9.654c34.499 23.359 51.754 62.916 51.754 118.666 0 83.618-73.517 136.999-133.94 136.999-60.43 0-129.225-35.772-140.356-110.635-11.12-74.851 35-109.801 66.416-158.559 20.958-32.501 34.532-65.436 40.755-98.792z"
								></path>
							</svg>
							<Icon
								mode="svg"
								class="svgfont svgfont-item mx-1 mr-4"
								:size="item.iconSize || 20"
								:name="item.icon"
								v-if="item.icon && !item.hot"
							/>
							<span class="flex-1">
								<span class="flex items-center">
									<span
                    class="item-name leading-6 flex items-center group-actived:bm-text-effect"
										:class="
											getTranslate(item.nameLangList, item.name) && getTranslate(item.introLangList, item.intro)
												? 'text-base font-medium'
												: 'text-sm'
										"
										v-if="getTranslate(item.nameLangList, item.name)"
										>{{ getTranslate(item.nameLangList, item.name) }}</span>
										<i class="item-tag" v-if="item.tag">{{item.tag}}</i>
									<span
										class="bm-bg-effect-trans bm-text-effect font-medium rounded text-xs h-4 leading-4 px-1 ml-[2px]"
										v-if="getTranslate(item.labelLangList, item.label)"
										>{{ getTranslate(item.labelLangList, item.label) }}</span
									>
									<span
										class="item-name leading-6 group-actived:bm-text-effect"
										:class="
											item.title && getTranslate(item.introLangList, item.intro) ? 'text-base font-medium' : 'text-sm'
										"
										v-else-if="item.title"
										>{{ item.title }}</span
									>
								</span>
								<span
									class="text-sm leading-6 font-light bm-text-gray group-hover:bm-text-black"
									v-if="getTranslate(item.introLangList, item.intro)"
								>
									{{ getTranslate(item.introLangList, item.intro) }}
								</span>
							</span>
							<Icon
								class="svgfont group-actived:bm-text-effect"
								mode="svg"
								:size="10"
								name="icon-navigator-checked"
								v-if="item.selected"
							/>
						</span>
					</nuxt-link-enhance>
				</SensorTrack>
			</div>
			<template v-else>
				<slot name="content" />
			</template>
		</div>
	</el-popover>
	</div>
</template>

<script>
import _get from 'lodash/get';
import commonMixins from '../mixins';
import Icon from './Icon';
import SensorTrack from './SensorTrack';
import NuxtLinkEnhance from './NuxtLinkEnhance';
import { useStore } from '~/common/js/patch';
// import { mapState } from 'vuex';
import i18nMessage from '../i18n';
export default {
	name: 'ComponentsDropdownMenuPicker',
	components: {
		NuxtLinkEnhance,
		SensorTrack,
		Icon,
	},

	mixins: [commonMixins],
	props: {
		disabled: {
			type: Boolean,
			default: false,
		},
		popperClass: {
			type: String,
			default: '',
		},
		size: {
			type: String,
			default: 'normal',
		},
		width: {
			type: String,
			default: 'auto',
		},
		reference: {
			type: String,
			default: '',
		},
		hot: {
			type: Boolean,
			default: false,
		},
		columns: {
			type: Boolean,
			default: false,
		},

		list: {
			type: Array,
			default() {
				return [];
			},
		},
		showIndicator: {
			type: Boolean,
			default: true,
		},
	},
	data() {
		return {
			actived: false,
			visible: false,
		};
	},
	computed: {
		showWelcomeBonus() {
			return this.store.showWelcomeBonus
		},
		// ...mapState({
		// 	showWelcomeBonus: (state) => state.showWelcomeBonus,
		// }),
		// 通过和store联动的方式进行
		computedPopperClass() {
			return `droplist-menu-popper-class ibm-font ${this.popperClass} ${this.size} ${
				this.showWelcomeBonus ? 'welcome-bonus' : ''
			}`;
		},
	},
	methods: {
		onSelect(item) {
			// 是否存在sensorName，则上报数据
			if (item.sensorName) this.$sensor.track(item.sensorName, item.sensorData);
			this.$emit('select', item);
		},
		getTranslate(langList, defaultValue) {
			const i18nExist = _get(i18nMessage?.[this.$$locale], defaultValue);

			let val = '';
			if (langList?.[this.$$transRouteLocale]) {
				val = langList?.[this.$$transRouteLocale];
			} else if (i18nExist) {
				val = defaultValue;
			} else {
				val = langList?.['en-US'] || defaultValue;
			}

			return val ? this.$t(val) : val;
		},
	},
	setup() {
		const store = useStore();
		return {
			store
		};
	}
};
</script>

<style lang="less" scoped>
@import '../assets/css/ui.variables.less';
.component-dropdown-menu-picker {
	.reference {
		height: @navigator_bar_height;
		&.small {
			height: @navigator_bar_height_small;
		}
		&.medium {
			height: @navigator_bar_height_medium;
		}
	}

	.svgfont-reference {
		// transition: transform 0.25s cubic-bezier(0.645, 0.045, 0.355, 1);
		&.actived {
			transform: rotateZ(180deg);
		}
	}
}
.item-tag {
  display: inline-block;
  padding: 0 8px;
  margin-left: 6px;
  background-color: #E5ECF0;
  border-radius: 4px;
  line-height: 22px;
  font-size: 10px;
  font-style: normal;
  vertical-align: middle;
}
</style>

<style lang="less">
@import '~/common/css/ui.variables.less';

.droplist-menu-popper-class {
	padding: 0 !important;
	background: @white_color !important;
	box-shadow: 0px 8px 36px @shadow_color !important;
	min-width: 200px !important;
	max-height: 90vh !important;
	overflow: auto !important;
	border: none !important;
	color: @black_color !important;
	border-bottom-left-radius: @base_spacing!important;
	border-bottom-right-radius: @base_spacing!important;
	// top: 80px !important;
	transform: translateY(-10px);
	margin-top: 0 !important;
	width: unset !important;
	&.small {
		// top: 56px !important;
	}

	&.medium {
		// top: 68px !important;
	}

	&.welcome-bonus {
		// top: 112px !important;

		&.small {
			// top: 88px !important;
		}
		&.medium {
			// top: 100px !important;
		}
	}

  .component-dropdown-menu-picker-columns-2 {
		display: flex;
    flex-wrap: wrap;
		> div {
			flex: 0 0 50%;
		}
	}

  .component-dropdown-menu-picker-columns-2 {
		display: flex;
    flex-wrap: wrap;
		> div {
			flex: 0 0 50%;
		}
	}

	.component-dropdown-menu-picker-columns-2 {
		display: flex;
		flex-wrap: wrap;
		> div {
			flex: 0 0 50%;
		}
	}
}
</style>
